import React from 'react'
import * as S from './styles'
import { currencyParser } from '../../../../utils'

const SummaryWirecard = ({ data }) => {
  return (
    <S.CardRequestValueContainer>
      <S.CardRequestAccount>
        <span>Valor: </span> {currencyParser(data.refundAmount, 'R$ ')}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>Bandeira:</span> {data.creditCardDetails.brand}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>Cartão:</span> **** **** **** {data.creditCardDetails.last4}
      </S.CardRequestAccount>
    </S.CardRequestValueContainer>
  )
}

export default SummaryWirecard
